import { useEffect, useState } from 'react';

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 500);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleBackToTop}
      aria-label="トップページへ戻る"
      className={`fixed right-6 md:right-10 bottom-6 md:bottom-10 z-40 w-11 h-11 md:w-12 md:h-12 border border-[#C9A84C]/50 bg-[#0A0A0F]/80 backdrop-blur-sm text-[#C9A84C] hover:bg-[#C9A84C]/15 hover:border-[#C9A84C]/80 transition-all duration-300 flex items-center justify-center cursor-pointer ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}
